import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateChild } from '@angular/router';
import { ActivatedRouteSnapshot, CanActivate} from '@angular/router';

import { TokenService } from './token.service';
import { LocalUserService } from './local-user.service';
import { HttpAuthenticationService } from './http-authentication.service';

import * as decode from 'jwt-decode';

import { Observable } from 'rxjs/Observable';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import 'rxjs/add/observable/of';

// Angular routes guard
// Declare this to your app.module as a service provider
// And use it as 'canActivateChild' guard in your app.routing module

@Injectable()
export class AuthorizationGuardService implements CanActivateChild, CanActivate {

	constructor(private token: TokenService, private router: Router,
		private localUser: LocalUserService,
		private authService: HttpAuthenticationService) {}

	canActivateChild(snap: ActivatedRouteSnapshot): boolean {
		return this.checkLoginAndAuthorization(snap.data.auth_level);
	}

	canActivate(snap: ActivatedRouteSnapshot): boolean {
		return this.checkLoginAndAuthorization(snap.data.auth_level);
	}

	// ------------------------------------
	// Make sure user is logged in
	// is authorized to access the route
	// ------------------------------------
	checkLoginAndAuthorization(expectedRole: number): boolean {

		const isLoggedIn = this.token.isLoggedIn();

		if (!isLoggedIn) {
			this.router.navigate(['pages', 'login']);
			return false;
		}

		const token = localStorage.getItem('token');
		const tokenPayload = decode(token);

		if (tokenPayload.authorization_level < expectedRole) {
			if (tokenPayload.authorization_level == 3){
				this.router.navigate(['tableaudebord']);
			}

			if (tokenPayload.authorization_level == 2){
				this.router.navigate(['mouvement', 'placement']);
			}
		}

		return tokenPayload.authorization_level >= expectedRole;
	}


}



// WEBPACK FOOTER //
// ./src/app/authentication/authorization-guard.service.ts